import React from "react";
import { AlertTriangle, XCircle } from "lucide-react";

/**
 * PublishBlockers — renders an explicit list of reasons a resource cannot be
 * published yet.  The `blockers` prop is an array of { key, message } objects.
 * When the list is empty, nothing is rendered.
 */
export function PublishBlockers({ blockers = [], className = "" }) {
  if (!blockers.length) return null;

  return (
    <div
      data-testid="publish-blockers"
      className={`rounded-lg border border-amber-700/50 bg-amber-950/30 p-4 ${className}`}
    >
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="w-4 h-4 text-amber-400 flex-shrink-0" />
        <span className="text-sm font-semibold text-amber-300">
          Cannot publish — {blockers.length} blocker{blockers.length !== 1 ? "s" : ""}
        </span>
      </div>
      <ul className="space-y-1.5">
        {blockers.map((b) => (
          <li
            key={b.key}
            data-testid={`blocker-${b.key}`}
            className="flex items-start gap-2 text-sm text-amber-200/80"
          >
            <XCircle className="w-3.5 h-3.5 text-amber-500 mt-0.5 flex-shrink-0" />
            {b.message}
          </li>
        ))}
      </ul>
    </div>
  );
}
